import { Component, OnInit, OnDestroy } from '@angular/core';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { ActivatedRoute } from '@angular/router';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { FormsTurnsService } from 'src/app/services/turns-services/forms-turns-service/forms-turns.service';

@Component({
  selector: 'app-turns-form-new-turn-schedule-dashboard',
  templateUrl: './turns-form-new-turn-schedule-dashboard.component.html',
  styleUrls: ['./turns-form-new-turn-schedule-dashboard.component.scss']
})
export class TurnsFormNewTurnScheduleDashboardComponent implements OnInit, OnDestroy {

  formid;
  form;
  getFormInfoSubscription: Subscription;

  constructor(private activatedRoute: ActivatedRoute,
    private headerBreadcrumbService: HeaderBreadcrumbService,
    private turnsFormsService: FormsTurnsService,
    private snackbarService: SnackBarService) { }

  ngOnInit() {
    this.formid = this.activatedRoute.snapshot.params['formid'];
    this.setBreadcrumb();
    this.getFormInfo();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-calendar-day', 'turns-page.new turn schedule', '/turns/form/' + this.formid, [new BRoute('turns-page.turns', '/turns'), new BRoute('turns-page.forms', '/turns/forms'), new BRoute('turns-page.form detail', '/turns/form/' + this.formid), new BRoute('turns-page.new turn schedule')]));
  }

  public getFormInfo() {
    this.getFormInfoSubscription = this.turnsFormsService.getFormInfo(this.formid).subscribe(
      (res) => {
        this.form = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  ngOnDestroy() {
    if (this.getFormInfoSubscription) { this.getFormInfoSubscription.unsubscribe(); }
  }
}
